const Icon = (props) => {
  const { size, children } = props
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round' aria-hidden='true'>
      {children}
    </svg>
  )
}

export const GitHubIcon = ({ size = 22 }) => (
  <Icon size={size}>
    <path d='M15 22v-4a4.8 4.8 0 0 0-1-3.5c3 0 6-2 6-5.5.08-1.25-.27-2.48-1-3.5.28-1.15.28-2.35 0-3.5 0 0-1 0-3 1.5-2.64-.5-5.36-.5-8 0C6 2 5 2 5 2c-.3 1.15-.3 2.35 0 3.5A5.4 5.4 0 0 0 4 9c0 3.5 3 5.5 6 5.5-.39.49-.68 1.05-.85 1.65-.17.6-.22 1.23-.15 1.85v4' />
    <path d='M9 18c-4.51 2-5-2-7-2' />
  </Icon>
)

export const LinkedInIcon = ({ size = 22 }) => (
  <Icon size={size}>
    <path d='M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-4 0v7h-4v-7a6 6 0 0 1 6-6z' />
    <rect x='2' y='9' width='4' height='12' />
    <circle cx='4' cy='4' r='2' />
  </Icon>
)

export const MailIcon = ({ size = 22 }) => (
  <Icon size={size}>
    <rect x='2' y='4' width='20' height='16' rx='2' />
    <path d='m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7' />
  </Icon>
)

export const ArrowRightIcon = ({ size = 18 }) => (
  <Icon size={size}>
    <path d='M5 12h14' />
    <path d='m12 5 7 7-7 7' />
  </Icon>
)

export const ArrowUpRightIcon = ({ size = 16 }) => (
  <Icon size={size}>
    <path d='M7 7h10v10' />
    <path d='M7 17 17 7' />
  </Icon>
)
